import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-mail-icon',
  templateUrl: './communication-mail.component.html'
})
export class CommunicationMailComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
